<template>
    <footer class="ui-footer" :class="footerClasses()">
      <div class="ui-footer__app">
        <p v-once class="ui-footer__app__copyright">
          {{ $t('common.note.copyright', { year,  version }) }}
        </p>
        <nav class="ui-footer__app__nav">
          <v-btn flat color="primary" @click="showPrivacy">Privacy Policy</v-btn>
          <v-btn flat color="primary" @click="showTerms">Terms of Use</v-btn>
        </nav>
      </div>
       <terms-of-use-dialog ref="termsOfUseDialog"/>
       <privacy-policy-dialog ref="privacyPolicyDialog"/>
    </footer>
</template>

<style lang="scss" scoped>

  // @import '../../styles/variables';

  $link-hover: orange;
  $background: white;
  $medium-gray: #EEEEEE;
  $light-gray: #ffffff;
  $copyright: #222;
  $link: #01579B;

  .ui-footer {
    clear: both;
    width: 100%;
    margin: 0;
    margin-top: 40px;

    &.ui--hide {
      display: none !important;
    }
    
    &__app {
      padding: 24px 12px;
      font-size: 14px;

      &__copyright {
        color: $copyright;
        text-align: center;
        margin-bottom: 8px;
      }

      &__nav {
        text-align: center;

        a {
          display: inline-block;
          margin: 0 16px;
          margin-bottom: 5px;
          color: $link;
          text-decoration: none;

          &:hover {
            color: $link-hover;
          }
        }
      }
    }
  }
</style>

<script>
  import consts from '@/core/consts'
  import TermsOfUseDialog from '@/components/dialogs/TermsOfUseDialog'
  import PrivacyPolicyDialog from '@/components/dialogs/PrivacyPolicyDialog'

  export default {
    name: 'UiAppFooter',
    props: {
      auth: Boolean,
      hide: Boolean,
      version: String
    },
    components: {
      TermsOfUseDialog,
      PrivacyPolicyDialog
    },
    data () {
      return {
        year: new Date().getFullYear(),
        consts
      }
    },
    methods: {
      footerClasses () {
        if (this.hide) {
          return 'ui--hide'
        }
        return ''
      },
      showTerms() {
        this.$refs.termsOfUseDialog.open()
      },
      showPrivacy() {
        this.$refs.privacyPolicyDialog.open()
      },
      showFeedbackDialog () {
        this.dialog(
          {
            opts: {
              width: 488,
              title: this.lang('common.title.giveFeedback')
            },
            component: 'UiFeedback'
          }
        )
      }
    }
  }
</script>

<i18n src='./Footer.locale.json'></i18n>


// WEBPACK FOOTER //
// src/core/components/Footer.vue